"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroHash = void 0;
exports.zeroHash = '0x0000000000000000000000000000000000000000000000000000000000000000';
//# sourceMappingURL=bytes.js.map